import { render, staticRenderFns } from "./mappingAttr.vue?vue&type=template&id=49b1c78e&scoped=true"
import script from "./mappingAttr.vue?vue&type=script&lang=js"
export * from "./mappingAttr.vue?vue&type=script&lang=js"
import style0 from "./mappingAttr.vue?vue&type=style&index=0&id=49b1c78e&prod&lang=css"
import style1 from "./mappingAttr.vue?vue&type=style&index=1&id=49b1c78e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b1c78e",
  null
  
)

export default component.exports